<template>
  <div class="bg-primary tab-header">
    <h5 class="bg-primary p-3 my-auto"> {{ title }} </h5>
      <div class="p-3 pr-5 pd-0 col-lg-3 search">
        <div class="search-icon"><i class="fa fa-search"></i></div>
          <b-input-group>
            <b-form-input class="search-text" @input="emitInput" :placeholder="$t('WORKFLOW.SEARCH')" ref="searchInput"/>
            <div v-show="showClear" class="clear-btn" @click="clearFilter" v-html="svg.broom"></div>
          </b-input-group>
      </div>
  </div>
</template>

<script>
import svg from '../../_svg.js'

export default {
  data () {
    return {
      svg: svg,
      showClear: false
    }
  },
  props: {
    title: String
  },
  methods: {
    emitInput (input) {
      this.$emit('filterInput', input)
      if (input !== '') this.showClear = true
      else this.showClear = false
    },
    clearFilter () {
      this.$refs.searchInput.$el.value = ''
      this.emitInput('')
      this.showClear = false
    }
  }
}
</script>

<style lang="scss" scoped>
 .search {
    display: flex;
    justify-content: flex-end;

    .search-text {
      border-radius: 20px;
      padding: 8px 15px;
      border-color: #939dad ;
    }


    .clear-btn {
      font-size: 1.3rem;
      padding: 5px 0px;
      cursor: pointer;
      z-index: 10;
      right: 1rem;
      position: absolute;
    }

    .search-icon {
      font-size: 1.3rem;
      padding: 6px 10px;
    }
  }


  .tab-header h5{
    text-transform: uppercase;
  }

  .tab-header{
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/SearchBar.vue